import Layout from '@/layout'
// import ParentView from '@/components/ParentView'

const asyncTakeSampleManagementRoutes =
{
  path: '/lab/takeSampleManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '样品采样管理',
  funcPerms: 'lab:sample',
  alwaysShow: true,
  meta: {
    title: '样品采样管理',
    icon: 'sample',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'sampleRegistration',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/index'),
      funcPerms: 'lab:sample:register',
      name: 'sampleRegistration',
      meta: {
        title: '样品登记',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleReview',
      component: () => import('@/views/lab/takeSampleManagement/sampleReview/index'),
      funcPerms: 'lab:sample:register',
      name: 'sampleReview',
      meta: {
        title: '样品评审',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegistration/add-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step1'),
      funcPerms: 'lab:sample:register:add',
      name: 'SampleRegistrationAddStep1',
      hidden: true,
      meta: {
        title: '新增受理信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegistration/add-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step2'),
      funcPerms: 'lab:sample:register:add',
      name: 'SampleRegistrationAddStep2',
      hidden: true,
      meta: {
        title: '新增样品信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegistration/edit-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step1'),
      funcPerms: 'lab:sample:register:edit',
      name: 'sampleRegistrationEdit-step1',
      hidden: true,
      meta: {
        title: '编辑受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegistration/edit-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step2'),
      funcPerms: 'lab:sample:register:edit',
      name: 'sampleRegistrationEdit-step2',
      hidden: true,
      meta: {
        title: '编辑样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegistration/view-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step1'),
      funcPerms: 'lab:sample:register:view',
      name: 'sampleRegistrationView-step1',
      hidden: true,
      meta: {
        title: '查看受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegistration/view-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegistration/step2'),
      funcPerms: 'lab:sample:register:view',
      name: 'sampleRegistrationView-step2',
      hidden: true,
      meta: {
        title: '查看样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/sampleRegister_vector',
    //   component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/index'),
    //   funcPerms: 'lab:sample:vector_register',
    //   name: 'sampleRegister_vector',
    //   meta: {
    //     title: '消毒质量监测样品登记',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'sampleRegister_vector/add-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step1'),
      funcPerms: 'lab:sample:vector_register:add',
      name: 'SampleRegisterAddStep1Vector',
      hidden: true,
      meta: {
        title: '消毒质量监测新增受理信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegister_vector/add-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step2'),
      funcPerms: 'lab:sample:vector_register:add',
      name: 'SampleRegisterAddStep2Vector',
      hidden: true,
      meta: {
        title: '消毒质量监测新增样品信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegister_vector/edit-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step1'),
      funcPerms: 'lab:sample:vector_register:edit',
      name: 'sampleRegisterEdit-step1_vector',
      hidden: true,
      meta: {
        title: '消毒质量监测编辑受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_vector/edit-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step2'),
      funcPerms: 'lab:sample:vector_register:edit',
      name: 'sampleRegisterEdit-step2_vector',
      hidden: true,
      meta: {
        title: '消毒质量监测编辑样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_vector/view-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step1'),
      funcPerms: 'lab:sample:vector_register:view',
      name: 'sampleRegisterView-step1_vector',
      hidden: true,
      meta: {
        title: '消毒质量监测查看受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_vector/view-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_vector/step2'),
      funcPerms: 'lab:sample:vector_register:view',
      name: 'sampleRegisterView-step2_vector',
      hidden: true,
      meta: {
        title: '消毒质量监测查看样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // {
    //   path: '/sampleRegister_publicHealth',
    //   component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/index'),
    //   funcPerms: 'lab:sample:ph_register',
    //   name: 'sampleRegister_PH',
    //   meta: {
    //     title: '环监科样品登记',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // },
    {
      path: 'sampleRegister_publicHealth/add-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step1'),
      funcPerms: 'lab:sample:ph_register:add',
      name: 'SampleRegisterAddStep1PH',
      hidden: true,
      meta: {
        title: '环监科新增受理信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegister_publicHealth/add-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step2'),
      funcPerms: 'lab:sample:ph_register:add',
      name: 'SampleRegisterAddStep2PH',
      hidden: true,
      meta: {
        title: '环监科新增样品信息',
        icon: 'index',
        affix: false,
        noCache: false
      }
    },
    {
      path: 'sampleRegister_publicHealth/edit-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step1'),
      funcPerms: 'lab:sample:ph_register:edit',
      name: 'sampleRegisterEdit-step1_PH',
      hidden: true,
      meta: {
        title: '环监科编辑受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_publicHealth/edit-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step2'),
      funcPerms: 'lab:sample:ph_register:edit',
      name: 'sampleRegisterEdit-step2_PH',
      hidden: true,
      meta: {
        title: '环监科编辑样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_publicHealth/view-step1',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step1'),
      funcPerms: 'lab:sample:ph_register:view',
      name: 'sampleRegisterView-step1_PH',
      hidden: true,
      meta: {
        title: '环监科查看受理信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleRegister_publicHealth/view-step2',
      component: () => import('@/views/lab/takeSampleManagement/sampleRegister_publicHealth/step2'),
      funcPerms: 'lab:sample:ph_register:view',
      name: 'sampleRegisterView-step2_PH',
      hidden: true,
      meta: {
        title: '环监科查看样品信息',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleDispense',
      component: () => import('@/views/lab/takeSampleManagement/sampleDispense/index'),
      funcPerms: 'lab:sample:dispense',
      name: 'sampleDispense',
      meta: {
        title: '样品分配',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleDispense/dispenseDepart',
      component: () => import('@/views/lab/takeSampleManagement/sampleDispense/dispenseDepart'),
      funcPerms: 'lab:sample:dispense:depart',
      name: 'dispenseDepart',
      hidden: true,
      meta: {
        title: '分配科室',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleDispense/dispenseDepart_vector',
      component: () => import('@/views/lab/takeSampleManagement/sampleDispense/dispenseDepart_vector'),
      funcPerms: 'lab:sample:dispense:depart',
      name: 'dispenseDepartVector',
      hidden: true,
      meta: {
        title: '病媒分配科室',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleDispense/dispenseDepart_PH',
      component: () => import('@/views/lab/takeSampleManagement/sampleDispense/dispenseDepart_PH'),
      funcPerms: 'lab:sample:dispense:depart',
      name: 'dispenseDepartPH',
      hidden: true,
      meta: {
        title: '公卫分配科室',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'sampleDispense/printFlowCard_office',
      component: () => import('@/views/lab/takeSampleManagement/sampleDispense/printFlowCard_office'),
      funcPerms: 'lab:sample:dispense:depart',
      name: 'printFlowCard_office',
      hidden: true,
      meta: {
        title: '流程卡',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/index'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'prepareReport',
      meta: {
        title: '编制报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport/revertFileName',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/revertFileName'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'revertFileName',
      hidden: true,
      meta: {
        title: '回退检测结果',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport/WebEdit',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/WebEdit'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'WebEdit',
      hidden: true,
      meta: {
        title: '编辑报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport/WebEdit/view',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/WebEdit'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'WebEditView',
      hidden: true,
      meta: {
        title: '查看报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport/view_record',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/view_record'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'ViewRecord',
      hidden: true,
      meta: {
        title: '查看原始记录表',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'prepareReport/view',
      component: () => import('@/views/lab/takeSampleManagement/prepareReport/view'),
      funcPerms: 'lab:sample:prepareReport',
      name: 'prepareReportView',
      hidden: true,
      meta: {
        title: '预览报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'reportReview',
      component: () => import('@/views/lab/takeSampleManagement/reportReview/index'),
      funcPerms: 'lab:sample:report:review',
      name: 'reportReview',
      meta: {
        title: '报告审核',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'printReport',
      component: () => import('@/views/lab/takeSampleManagement/printReport/index'),
      funcPerms: 'lab:sample:report:review',
      name: 'printReport',
      meta: {
        title: '报告打印',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }, {
      path: 'sendReport',
      component: () => import('@/views/lab/takeSampleManagement/sendReport/index'),
      funcPerms: 'lab:sample:report:review',
      name: 'sendReport',
      meta: {
        title: '报告发放',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'notArchiveReport',
      component: () => import('@/views/lab/takeSampleManagement/notArchiveReport/index'),
      funcPerms: 'lab:sample:report:review',
      name: 'notArchiveReport',
      meta: {
        title: '报告待归档',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }, {
      path: 'archiveReport',
      component: () => import('@/views/lab/takeSampleManagement/archiveReport/index'),
      funcPerms: 'lab:sample:report:review',
      name: 'archiveReport',
      meta: {
        title: '报告已归档',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },

    {
      path: 'reportReview/view',
      component: () => import('@/views/lab/takeSampleManagement/reportReview/view'),
      funcPerms: 'lab:sample:report:review',
      name: 'ReportReviewView',
      hidden: true,
      meta: {
        title: '预览报告',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'reportReview/view_record',
      component: () => import('@/views/lab/takeSampleManagement/reportReview/view_record'),
      funcPerms: 'lab:sample:report:review',
      name: 'reportReviewViewRecord',
      hidden: true,
      meta: {
        title: '查看原始记录表',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }

  ]
}

export default asyncTakeSampleManagementRoutes
